import moment from 'moment-timezone';
import { List, Map } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';
import FeatureFlagStore from './FeatureFlagStore';
import { getOrderSignature, hasRecentMatch, RECENT_ORDERS_LIMIT } from '../helpers/DuplicateOrder';

export class RecentOrdersStore extends BaseStore {

    getInitialState () {
        return new Map({
            orders: new List(),
            historyOrders: new List(),
            acknowledgedOrderId: null
        });
    }

    serialize () {
        return this.state.remove('historyOrders').toJS();
    }

    handleOrderPaid ({ order }) {
        const signature = getOrderSignature(order);
        const alreadyRecorded = this.state.get('orders')
            .some((recent) => recent.get('orderId') === order.id);

        if (!signature || alreadyRecorded) {
            return;
        }

        const orders = this.state.get('orders')
            .unshift(new Map({ orderId: order.id, signature, paidAt: moment().toISOString() }))
            .take(RECENT_ORDERS_LIMIT);

        this.setState(this.state.merge({ orders, acknowledgedOrderId: null }));
    }

    handleRecentOrdersLoaded ({ orders }) {
        const historyOrders = orders
            .filter((order) => order.purchaseDate)
            .map((order) => new Map({
                orderId: order.id,
                signature: getOrderSignature(order),
                paidAt: moment(order.purchaseDate).toISOString()
            }))
            .toList();

        this.setState(this.state.set('historyOrders', historyOrders));
    }

    handleAcknowledged ({ orderId }) {
        this.setState(this.state.set('acknowledgedOrderId', orderId));
    }

    getRecentOrders () {
        return this.state.get('orders')
            .concat(this.state.get('historyOrders'))
            .map((recent) => recent.toJS())
            .toArray();
    }

    requiresDuplicateWarning (order) {
        if (!FeatureFlagStore.get('enableDuplicateOrderCheck') || !order || !order.id) {
            return false;
        }

        if (this.state.get('acknowledgedOrderId') === order.id) {
            return false;
        }

        return hasRecentMatch({
            signature: getOrderSignature(order),
            recentOrders: this.getRecentOrders(),
            orderId: order.id
        });
    }

    getActionHandlers () {
        return {
            [ ActionTypes.ORDER_PAID ]: this.handleOrderPaid,
            [ ActionTypes.RECENT_ORDERS_LOADED ]: this.handleRecentOrdersLoaded,
            [ ActionTypes.DUPLICATE_ORDER_ACKNOWLEDGED ]: this.handleAcknowledged,
            [ ActionTypes.LOGGED_OUT ]: this.resetState
        };
    }

}

const instance = new RecentOrdersStore({ storageKey: 'recent-orders', expires: 60 * 60 });

export default instance;
